import { MealOfDayDivision } from '@/api/types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ComponentIcon from '@/features/Icons/ComponentIcon'
import SoupIcon from '@/features/Icons/SoupIcon'
import CarrotIcon from '@/features/Icons/CarrotIcon'

export default function MealDivisionTypeBadge({
  mealDivision,
}: {
  mealDivision: MealOfDayDivision
}) {
  const { t } = useTranslation()
  switch (mealDivision.type) {
    case 'MEAL_PART':
      return (
        <div className="badge-mealDivisionType">
          <ComponentIcon />
          {t(`mealParts.${mealDivision.mealPart}`)}
        </div>
      )
    case 'INGREDIENT':
      return (
        <div className="badge-mealDivisionType">
          <CarrotIcon />
        </div>
      )
    case 'RECIPE':
      return (
        <div className="badge-mealDivisionType">
          <SoupIcon />
        </div>
      )
  }
}
